module.exports = __webpack_public_path__ + "img/01-pic.74213c07.png";